<template>
  <div class="backStack-side-menu-wrap">
    <div class="side-menu-body-wrap">
      <a-menu
        style="width: 100%"
        :selectedKeys="current"
        :openKeys.sync="current"
        mode="inline"
        @click="handleClick"
      >
        <a-sub-menu v-for="sub in sideMenus" :key="sub.title">
          <span slot="title">
            <span :class="{ titleActived: titleActieved(sub.title) }">{{
              sub.title
            }}</span>
          </span>
          <a-menu-item v-for="item in sub.child" :key="item.key">
            {{ item.name }}
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import { sideOptions, nameMap } from './configs'

export default {
  props: {
    sideOpen: Array
  },
  data() {
    return {
      sideOptions,
      current: []
    }
  },
  components: {},
  computed: {
    ...mapGetters('user', ['account', 'role']),
    sideMenus() {
      let list = []
      const userList = [
        '账户信息',
        '开放许可管理',
        '需求管理',
        '运营管理',
        '服务机构',
        '收藏管理'
      ]
      const copyList = cloneDeep(this.sideOptions)
      switch (this.role) {
        case 'admin':
        case 'bus':
          list = copyList
          break
        case 'user':
          copyList.forEach(option => {
            if (userList.indexOf(option.title) >= 0) {
              // if (option.title === '服务机构') {
              //   option.child.shift()
              // }
              list.push({
                title: option.title,
                child: option.child
              })
            }
          })
          break
        default:
          list = []
          break
      }
      return list
    }
  },
  watch: {
    $route(to) {
      const { key } = to.query
      this.setCurrentKeys(key)
    }
  },
  mounted() {
    const { key } = this.$route.query
    this.setCurrentKeys(key)
  },
  methods: {
    setCurrentKeys(key) {
      if (!key) return
      const parent = nameMap[key]
      this.current = [parent, key]
    },
    handleClick(e) {
      const { key, keyPath } = e
      const name = key
      const meta = keyPath[1]
      this.setCurrentKeys(key)
      this.$emit('sideMenuClick', { name, meta })
    },
    titleActieved(key) {
      return this.current.includes(key)
    }
  }
}
</script>
